import React from 'react';
import MuiAlertIcon from '@material-ui/icons/NotificationImportant';
import CriticalAlertIcon from '@material-ui/icons/Warning';

export default function AlertIcon(props) {
    if(props.critical) {
        return (
            <CriticalAlertIcon color={props.color} />
        )
    } else {
        return (
            <MuiAlertIcon color={props.color} />
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/AlertIcon.js